/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { SOCIAL_ACCOUNTS_IMAGES, UNABLE_TO_UNLINK_MESSAGES } from './models';
import { ExtendedLinkedAccount, BFFExtendedLinkedAccount } from './types';

export const extendLinkedAccounts = (linkedAccounts: BFFExtendedLinkedAccount[]): ExtendedLinkedAccount[] =>
  linkedAccounts.map(account => ({
    ...account,
    image: SOCIAL_ACCOUNTS_IMAGES[account.provider],
    unlinkMessage: UNABLE_TO_UNLINK_MESSAGES[account.provider]
  }));
